<template>
	<div class="multi-select-action-bar">
		<div class="action-left">
			<el-button @click="handleCancel" size="medium">取消</el-button>
		</div>
		<div class="action-center">
			<span class="selected-count">已选择 {{ selectedCount }} 条消息</span>
		</div>
		<div class="action-right">
			<el-button
				@click="handleQuote"
				:disabled="selectedCount === 0"
				size="medium">
				<i class="el-icon-chat-line-square"></i> 引用
			</el-button>
			<el-button
				type="primary"
				@click="handleForward"
				:disabled="selectedCount === 0"
				size="medium">
				转发({{ selectedCount }})
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MultiSelectActionBar',
	props: {
		selectedCount: {
			type: Number,
			default: 0
		}
	},
	methods: {
		handleCancel() {
			this.$emit('cancel');
		},
		handleForward() {
			if (this.selectedCount > 0) {
				this.$emit('forward');
			}
		},
		// 🔥 处理引用操作
		handleQuote() {
			if (this.selectedCount > 0) {
				this.$emit('quote');
			}
		}
	}
}
</script>

<style scoped>
.multi-select-action-bar {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	height: 60px;
	background: #fff;
	border-top: 1px solid #e0e0e0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 20px;
	z-index: 1000;
	box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
}

.action-left,
.action-right {
	flex: 0 0 auto;
	display: flex;
	gap: 8px;
}

.action-center {
	flex: 1;
	text-align: center;
}

.selected-count {
	font-size: 14px;
	color: #666;
	font-weight: 500;
}
</style>
